import { usePermissionGuard } from "../../hooks";
import { PermissionGuardProps } from "./permission.guard.props";

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  allowedRoles,
  children,
}) => {
  const { isAuthorized } = usePermissionGuard(allowedRoles);

  if (!isAuthorized) {
    return <></>; // No tiene permisos → no se muestra nada
  }

  return <>{children}</>; // Sí tiene permisos → muestra el contenido
};

export default PermissionGuard;
